import { format } from "date-fns";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { BsEnvelope, BsFillTelephoneFill } from "react-icons/bs";
import { IoCloseCircleOutline } from "react-icons/io5";
import orgApi from "../../../api/org_api";
import {
  Breadcrumb,
  CustomDatePicker,
  FooterButtons,
  FunnelIconButton,
  IconButton,
  Label,
  Paragraph,
  Table,
  Text,
} from "../../../component/common";
import { SearchableDropdown } from "../../../component/common/SearchableDropdown";
import PaginationButtons from "../../../component/PaginationButtons";
import S from "../../../Services/GeneralServices";
import { getTz } from "../../../utils/CommonMethods";
import { formatDropdownOptions, sevenDaysAgo } from "../../../utils/constant";
import { cn } from "../../../utils/lib";
import { calculatePercentage } from "./TAReport";

const JDReport = () => {
  const org = JSON.parse(localStorage.getItem("user__details")?.toString()!);
  const locationList = [
    { value: "India", label: "India" },
    { value: "USA", label: "USA" },
    { value: "All", label: "All" },
  ];

  const [schedule, setSchedule] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [pages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPost, setTotal] = useState(0);
  const [showStats, setShowStats] = useState(false);
  const [stats, setStats] = useState([] as any);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [level, setLevel] = useState("");
  const [levelList, setLevelList] = useState([] as any);
  const [selectedPostId, setSelectedPost] = useState("");
  // const [search, setSearch] = useState<string>("");
  const [showFilter, setShowFilter] = useState(false);
  const [dateFilter, setDateFilter] = useState<{
    from: Date | null;
    to: Date | null;
    location: string;
  }>({ from: sevenDaysAgo, to: new Date(), location: "All" });
  const isNamIT = org.org_name === "NAM IT" ? true : false;
  // const [debouncedSearch, setDebouncedSearch] = useState<string>("");

  useEffect(() => {
    getTableData();
    getSchedule(dateFilter.from, dateFilter.to);
  }, []);

  const handleFromDateChange = (date: Date | null) =>
    setDateFilter({ ...dateFilter, from: date });
  const handleToDateChange = (date: Date | null) =>
    setDateFilter({ ...dateFilter, to: date });
  const clearFilter = () => {
    setDateFilter({ from: sevenDaysAgo, to: new Date(), location: "All" });
    setShowFilter(false);
  };
  // useEffect(() => {
  //   const timerId = setTimeout(() => {
  //     setDebouncedSearch(search);
  //   }, 1000);
  //   return () => {
  //     clearTimeout(timerId);
  //   };
  // }, [search]);

  // useEffect(() => {
  //   getSchedule();
  // }, [debouncedSearch]);

  const getSchedule = async (from: Date | null, to: Date | null) => {
    const data = {
      from,
      to,
      location: dateFilter.location === "All" ? "" : dateFilter.location,
    };
    const res = await orgApi.jdReport(org.id, data);
    setSchedule(res?.data?.org);
    setTotal(res?.data?.org?.length);
    const t = Math.ceil(res?.data?.org?.length / 10);
    setTotalPages(t);
    const fromP = 0;
    const toP = 10;
    const d = res?.data?.org?.slice(fromP, toP);
    setPages(d);
    setCurrentPage(0);
  };

  useEffect(() => {
    const from = currentPage * 10;
    let to = currentPage * 10 + 10;
    currentPage * 10 + 10 > totalPost && (to = totalPost);
    const d = schedule.slice(from, to);
    setPages(d);
  }, [currentPage]);

  useEffect(() => {
    if (showStats) {
      nextPage(selectedPostId, selectedStatus);
    }
  }, [level]);

  const nextPage = async (post_id: string, status: string) => {
    setStats([]);
    const data = { status, level: level === "" ? null : level };
    const res = await orgApi.jdReportSchedule(post_id, data);
    setStats(res.data.schedule);
    if (res && res.data.schedule.length > 0 && levelList.length === 0) {
      const maxValue = res.data.schedule.reduce(
        (max: any, obj: any) => (obj.level > max ? obj.level : max),
        res.data.schedule[0].level,
      );
      setLevelList(
        Array.from({ length: maxValue }, (_, index) => `${index + 1}`),
      );
    }
    setSelectedStatus(status);
    setSelectedPost(post_id);
    setShowStats(true);
  };

  const getTableData = () => {
    const columns = [
      // { label: "S.No", accessor: "s_no" },
      { label: "Unique ID", accessor: "unique_id" },
      { label: "Post Title", accessor: "post_title" },
      ...(isNamIT ? [{ label: "Location", accessor: "location" }] : []),
      { label: "Profile", accessor: "setup" },
      { label: "Scheduled", accessor: "scheduled" },
      { label: "Rescheduled", accessor: "rescheduled" },
      { label: "Cancelled", accessor: "cancelled" },
      { label: "Completed", accessor: "completed" },
      { label: "Selected", accessor: "selected" },
      { label: "Rejected", accessor: "rejected" },
      { label: "No Show", accessor: "no_show" },
      { label: "Proxy", accessor: "proxy" },
      { label: "Profile vs Schedule", accessor: "profile_vs_schedule" },
      { label: "Schedule vs Reschedule", accessor: "profile_vs_reschedule" },
      { label: "Schedule vs Completed", accessor: "schedule_vs_completed" },
      { label: "Completed vs Proxy", accessor: "completed_vs_proxy" },
      { label: "Completed vs No Show", accessor: "completed_vs_no_show" },
      { label: "Completed vs Selected", accessor: "completed_vs_selected" },
      { label: "Completed vs Rejected", accessor: "completed_vs_rejected" },
    ];
    const data =
      pages &&
      pages.length &&
      pages.map((item: any, index: number) => {
        const completed = +item.completed + +item.selected + +item.rejected;
        const scheduled = +item.scheduled + completed;

        return {
          unique_id: <Text key={index}>{item.unique_id}</Text>,
          post_title: <Text>{item.job_title}</Text>,
          location: <Text>{item.location}</Text>,
          setup: <Text>{item.setup}</Text>,
          scheduled: (
            <Text
              className={cn(
                "text-xs ",
                item.scheduled > 0 &&
                  "cursor-pointer hover:text-blue-500 hover:text-xs hover:font-semibold",
              )}
              onClick={() =>
                item.scheduled > 0 && nextPage(item.post_id, "Scheduled")
              }
            >
              {scheduled || "0"}
            </Text>
          ),
          rescheduled: (
            <Text
              className={cn(
                "text-xs ",
                item.rescheduled > 0 &&
                  "cursor-pointer hover:text-blue-500 hover:text-xs hover:font-semibold",
              )}
              onClick={() =>
                item.rescheduled > 0 && nextPage(item.post_id, "Rescheduled")
              }
            >
              {item.rescheduled}
            </Text>
          ),
          completed: (
            <Text
              className={cn(
                "text-xs ",
                item.completed > 0 &&
                  "cursor-pointer hover:text-blue-500 hover:text-xs hover:font-semibold",
              )}
              onClick={() =>
                item.completed > 0 && nextPage(item.post_id, "Completed")
              }
            >
              {completed || "0"}
            </Text>
          ),
          no_show: (
            <Text
              className={cn(
                "text-xs ",
                item.no_show > 0 &&
                  "cursor-pointer hover:text-blue-500 hover:text-xs hover:font-semibold",
              )}
              onClick={() =>
                item.no_show > 0 && nextPage(item.post_id, "No Show")
              }
            >
              {item.no_show}
            </Text>
          ),
          proxy: (
            <Text
              className={cn(
                "text-xs ",
                item.proxy > 0 &&
                  "cursor-pointer hover:text-blue-500 hover:text-xs hover:font-semibold",
              )}
              onClick={() => item.proxy > 0 && nextPage(item.post_id, "Proxy")}
            >
              {item.proxy}
            </Text>
          ),
          rejected: (
            <Text
              className={cn(
                "text-xs ",
                item.rejected > 0 &&
                  "cursor-pointer hover:text-blue-500 hover:text-xs hover:font-semibold",
              )}
              onClick={() =>
                item.rejected > 0 && nextPage(item.post_id, "Rejected")
              }
            >
              {item.rejected}
            </Text>
          ),
          cancelled: (
            <Text
              className={cn(
                "text-xs ",
                item.cancelled > 0 &&
                  "cursor-pointer hover:text-blue-500 hover:text-xs hover:font-semibold",
              )}
              onClick={() =>
                item.cancelled > 0 && nextPage(item.post_id, "Cancelled")
              }
            >
              {item.cancelled}
            </Text>
          ),
          selected: (
            <Text
              className={cn(
                "text-xs ",
                item.selected > 0 &&
                  "cursor-pointer hover:text-blue-500 hover:text-xs hover:font-semibold",
              )}
              onClick={() =>
                item.selected > 0 && nextPage(item.post_id, "Selected")
              }
            >
              {item.selected}
            </Text>
          ),
          profile_vs_schedule: calculatePercentage(scheduled, item.setup),
          profile_vs_reschedule: calculatePercentage(
            item.rescheduled,
            item.setup,
          ),
          schedule_vs_completed: calculatePercentage(completed, scheduled),
          completed_vs_proxy: calculatePercentage(item.proxy, completed),
          completed_vs_no_show: calculatePercentage(item.no_show, completed),
          completed_vs_selected: calculatePercentage(item.selected, completed),
          completed_vs_rejected: calculatePercentage(item.rejected, completed),
        };
      });
    return { columns, data };
  };

  const getDetialsTableData = () => {
    const columns = [
      { label: "S.No", accessor: "s_no" },
      { label: "Candidate Details", accessor: "candidate_details" },
      { label: "Post Title", accessor: "post_title" },
      ...(isNamIT ? [{ label: "Location", accessor: "location" }] : []),
      { label: "Round", accessor: "round" },
      { label: "Interviewer Name", accessor: "interviewer_name" },
      { label: "Interview Date", accessor: "interview_date" },
      { label: "Interview Time", accessor: "interview_time" },
    ];

    if (selectedStatus === "Completed") {
      columns.push({ label: "Status", accessor: "status" });
    }
    if (
      selectedStatus === "Completed" ||
      selectedStatus === "Rejected" ||
      selectedStatus === "Selected" ||
      selectedStatus === "Submitted" ||
      selectedStatus === "Offered"
    ) {
      if (S.getOrgDomain() !== "nam-it.com") {
        columns.push({ label: "SIT Score", accessor: "sit_score" });
      } else {
        columns.push({ label: "Feedback", accessor: "feedback" });
      }
    }
    if (selectedStatus === "No Show" || selectedStatus === "Proxy") {
      columns.push({ label: "Reason", accessor: "reason" });
    }
    if (
      selectedStatus === "Completed" ||
      selectedStatus === "Rejected" ||
      selectedStatus === "Selected" ||
      selectedStatus === "Submitted" ||
      selectedStatus === "Offered"
    ) {
      columns.push({ label: "Recommended", accessor: "recommended" });
    }
    const data =
      stats &&
      stats.length > 0 &&
      stats.map((value: any, s_index: number) => {
        const baseData: any = {
          s_no: s_index + 1,
          candidate_details: (
            <div className=" flex flex-col items-start gap-1 truncate">
              <p className="font-semibold truncate">
                {value.candidate.first_name} {value.candidate.last_name}
              </p>
              <p className="flex flex-row items-center gap-1 truncate">
                <BsEnvelope /> &nbsp;
                <span>{value.candidate.email}</span>
              </p>
              <p className="flex flex-row items-center gap-1">
                <BsFillTelephoneFill /> &nbsp;
                {value.candidate.mobile}
              </p>
            </div>
          ),
          post_title: value.post.job_title,
          location: value.post.location,
          round: value.level,
          interviewer_name: `${value.interviewer?.candidate.first_name || ""} ${value.interviewer?.candidate.last_name || ""}`,
          interview_date: format(value.utc_starttime, "dd MMM yyyy"),
          interview_time: value.utc_endtime ? (
            <>
              {format(value.utc_starttime, "hh:mm a")} to{" "}
              {format(value.utc_endtime, "hh:mm a")} {getTz(value.candidate_tz)}
            </>
          ) : null,
        };
        if (selectedStatus === "Completed") {
          baseData.status =
            value.status === "Completed" &&
            value.feedback_status === "Completed" &&
            value.feedback.length > 0 &&
            value.feedback[0].interview_status !== "Completed"
              ? value.feedback[0].interview_status
              : value.status === "NR"
                ? "Next Round"
                : value.status;
        } else {
          baseData.status = value.status;
        }
        if (
          selectedStatus === "Completed" ||
          selectedStatus === "Rejected" ||
          selectedStatus === "Selected" ||
          selectedStatus === "Submitted" ||
          selectedStatus === "Offered"
        ) {
          if (value.feedback_status === "Completed") {
            if (S.getOrgDomain() !== "nam-it.com") {
              baseData.sit_score = (
                <p
                  className="p-2 text-xs 2xl:text-md cursor-pointer hover:text-blue-500 hover:text-sm hover:font-semibold"
                  onClick={() =>
                    value.feedback.length > 0
                      ? S.viewFeedback(value.id)
                      : window.open(value.feedback_url)
                  }
                >
                  {value.feedback.length > 0
                    ? value.feedback[0].sit_score
                    : value.sit}
                </p>
              );
            } else {
              baseData.feedback = (
                <p
                  className="p-2 text-xs 2xl:text-md cursor-pointer hover:text-blue-500 hover:text-sm hover:font-semibold"
                  onClick={() =>
                    value.feedback.length > 0
                      ? S.viewFeedback(value.id)
                      : window.open(value.feedback_url)
                  }
                >
                  <span className="underline text-blue-500">Link</span>
                </p>
              );
            }
          } else {
            if (S.getOrgDomain() !== "nam-it.com") {
              baseData.sit_score = <p className="p-2">-</p>;
            } else {
              baseData.feedback = <p className="p-2">-</p>;
            }
          }
        }
        if (selectedStatus === "No Show" || selectedStatus === "Proxy") {
          baseData.reason = (
            <p
              className="p-2 text-xs 2xl:text-md cursor-pointer text-primary font-semibold"
              onClick={() => S.viewFeedback(value.id)}
            >
              View Feedback
            </p>
          );
        }
        if (
          selectedStatus === "Completed" ||
          selectedStatus === "Rejected" ||
          selectedStatus === "Selected" ||
          selectedStatus === "Submitted" ||
          selectedStatus === "Offered"
        ) {
          if (
            value.feedback_status === "Completed" &&
            value.feedback &&
            value.feedback.length > 0 &&
            value.feedback[0]?.interview_status === "Completed"
          ) {
            baseData.recommended =
              S.getOrgDomain() !== "nam-it.com"
                ? value.feedback[0].recommended_status
                : value.feedback[0].eligible_for_this_position
                  ? "Yes"
                  : "No";
          } else {
            baseData.recommended = "-";
          }
        }
        return baseData;
      });
    return { columns, data };
  };

  return (
    <>
      <div className="h-[calc(100vh-100px)] w-[calc(100vw-120px)] 2xl:w-[calc(100vw-155px)] 2xl:h-[calc(100vh-115px)]">
        {!showStats ? (
          <div className=" h-full flex flex-col space-y-3">
            <div className="flex justify-between items-center">
              <Breadcrumb
                items={[
                  { text: "Reports", href: "/report_list" },
                  { text: `JD Report (${totalPost || 0})`, isActive: true },
                ]}
              />
              <div className="flex gap-2 items-center">
                {/* <SearchInput
                  placeholder="Search with Post Title"
                  value={search}
                  onChange={(e) => setSearch(e)}
                  onCancel={() => setSearch("")}
                /> */}
                <FunnelIconButton
                  onClick={() => setShowFilter(!showFilter)}
                  active={!!dateFilter.from || !!dateFilter.to}
                  className="p-2"
                />
                <AnimatePresence>
                  {showFilter && (
                    <motion.div
                      initial={{ opacity: 0, y: -10, scale: 0.95 }}
                      animate={{ opacity: 1, y: 0, scale: 1 }}
                      exit={{ opacity: 0, y: -10, scale: 0.95 }}
                      transition={{ duration: 0.2 }}
                      className="absolute right-6 top-[110px] z-20 w-60 rounded-lg border border-gray-200 bg-white p-3 shadow-lg 2xl:w-72 2xl:p-4"
                    >
                      <div className="space-y-2 2xl:space-y-2.5">
                        <div className="flex items-center justify-between gap-2">
                          <Paragraph text="Filter" color="text-gray-500" />
                          <IconButton
                            icon={
                              <IoCloseCircleOutline className="h-3.5 w-3.5 2xl:h-4 2xl:w-4" />
                            }
                            onClick={() => {
                              clearFilter();
                              setShowFilter(false);
                            }}
                            color="red"
                            className="-my-1 -mr-1 p-1"
                          />
                        </div>
                        <div className="space-y-2">
                          <CustomDatePicker
                            label="Start Date"
                            selected={dateFilter.from}
                            onBlur={() =>
                              dateFilter.from
                                ? handleFromDateChange(dateFilter.from)
                                : handleFromDateChange(new Date())
                            }
                            onChange={(date) => handleFromDateChange(date)}
                            showYearDropdown
                            showMonthDropdown
                            maxDate={dateFilter.to || new Date()}
                          />
                          <CustomDatePicker
                            label="End Date"
                            selected={dateFilter.to}
                            onBlur={() =>
                              dateFilter.to
                                ? handleToDateChange(dateFilter.to)
                                : handleToDateChange(new Date())
                            }
                            onChange={(date) => handleToDateChange(date)}
                            minDate={dateFilter.from || undefined}
                            showYearDropdown
                            showMonthDropdown
                            maxDate={new Date()}
                          />
                          {isNamIT && (
                            <div className="flex flex-col gap-1.5">
                              <Label text="Location" />
                              <SearchableDropdown
                                className="w-full"
                                placeholder="Select Location"
                                options={locationList}
                                value={dateFilter.location}
                                onChange={(e: any) =>
                                  setDateFilter({
                                    ...dateFilter,
                                    location: e.value,
                                  })
                                }
                              />
                            </div>
                          )}
                        </div>
                        <FooterButtons
                          primaryOnClick={() => {
                            setShowFilter(false);
                            getSchedule(dateFilter.from, dateFilter.to);
                          }}
                          secondaryOnClick={() => {
                            setDateFilter({
                              from: sevenDaysAgo,
                              to: new Date(),
                              location: "All",
                            });
                          }}
                          primaryText="Apply"
                          secondaryText="Reset"
                        />
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </div>
            <Table
              columns={getTableData().columns}
              data={getTableData().data}
              isStickyHeader
              isStacicRow
              containerHeight="h-[calc(100vh-197px)]"
            />
            {totalPost > 10 && (
              <PaginationButtons
                totalPages={totalPages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            )}
          </div>
        ) : (
          <div className="h-full flex flex-col space-y-4">
            <div className="flex justify-between items-start w-full">
              <Breadcrumb
                items={[
                  {
                    text: "JD Report",
                    onClick: () => {
                      setShowStats(!showStats);
                      setLevelList([]);
                    },
                  },
                  {
                    text: `${selectedStatus} (${stats.length})`,
                    isActive: true,
                  },
                ]}
              />
              <div className="flex justify-end items-center gap-2">
                <Label text="Select Round" className="w-[130px]" />
                <SearchableDropdown
                  options={[
                    { value: "", label: "All" },
                    ...formatDropdownOptions(levelList),
                  ]}
                  value={level}
                  onChange={(e) => setLevel(e.value)}
                  placeholder="Select Level"
                />
              </div>
            </div>
            <Table
              columns={getDetialsTableData().columns}
              data={getDetialsTableData().data}
              isStickyHeader
              containerHeight="h-[calc(100vh-145px)]"
            />
          </div>
        )}
      </div>
    </>
  );
};
export default JDReport;
